import {
  DesignObligation,
  Inclusion,
  MaturityStage,
  ProductBuildingBlock,
  TailorBuildingBlockInput,
  TailorTemplateBuildingBlockInput,
} from '@/gql/graphql';
import { GroupedBuildingBlock, SortedBuildingBlock } from '@/hooks/use-building-blocks/use-building-blocks.hook.core';

export const isSelectedBBIncluded = (bb: ProductBuildingBlock) => {
  return bb?.inclusion.actual === Inclusion.Included || bb?.inclusion.actual === Inclusion.Pending;
};

export const inclusionBBSelection = (
  groupedBB: GroupedBuildingBlock<DesignObligation | MaturityStage>,
  requestPayload: TailorBuildingBlockInput[] | TailorTemplateBuildingBlockInput[],
  sortedBBs: SortedBuildingBlock<DesignObligation | MaturityStage>,
) => {
  const difference = groupedBB.buildingBlocks.filter(
    (bb) => !requestPayload.find((req) => req.buildingBlockId === bb.id),
  );
  // if there's any BB's left in the group, we're selecting the first item in the group
  if (difference.length > 0) {
    return difference[0];
  }
  const selectedGroupIndex = sortedBBs.data.findIndex((group) => group.id === groupedBB.id);
  // in case there's only 1 that means that the last one is getting included we clear the selection
  if (sortedBBs.data.length - 1 === 0) {
    return undefined;
  }
  // in case it's the last one we select the previous one
  if (selectedGroupIndex + 1 >= sortedBBs.data.length - 1) {
    return sortedBBs.data[selectedGroupIndex - 1].buildingBlocks[0];
  }
  // in any other case just select the next one
  if (selectedGroupIndex + 1 <= sortedBBs.data.length - 1) {
    return sortedBBs.data[selectedGroupIndex + 1].buildingBlocks[0];
  }
};

export const getFirstBBContext = (
  context: 'included' | 'excluded',
  includedBBs: SortedBuildingBlock<DesignObligation | MaturityStage>,
  excludedBBs: SortedBuildingBlock<DesignObligation | MaturityStage>,
) => {
  const bbs = context === 'included' ? includedBBs : excludedBBs;
  if (bbs.data.length > 0) {
    return bbs.data[0].buildingBlocks[0];
  }
};
